<template>
<div>
  <div class="container">
    <h1>隐私政策</h1>
    <p  style="text-align:right;">
      <strong>更新时间：2021年11月22日</strong>
    </p>
    <p class="ti24">
      北京集橙信息技术有限公司是好兽药APP（以下简称「好兽药」或「我们」）的运营者，本《隐私政策》（以下简称「本政策」）阐述了好兽药将如何处理您的个人信息和隐私信息，并申明了好兽药对保护隐私的承诺。好兽药尊重并保护所有使用好兽药服务用户的个人隐私权。为了给您提供更准确、更有个性化的服务，好兽药会按照本隐私权政策的规定使用和披露您的个人信息。但好兽药将以高度的勤勉、审慎义务对待这些信息。除本隐私权政策另有规定外，在未征得您事先许可的情况下，好兽药不会将这些信息对外披露或向第三方提供。好兽药会不时更新本隐私权政策。 您在同意好兽药网络服务使用协议之时，即视为您已经同意本隐私权政策全部内容。本隐私权政策属于好兽药使用协议不可分割的一部分。 
      <span class="text-fw">
        请您在向好兽药提交个人信息或隐私信息之前，阅读、了解并同意本政策和任何补充政策。本隐私政策要点如下：
      </span>
    </p>
     <p>
      <strong  class="ti24">● 我们会逐一说明我们对个人信息收集、使用、保护等处理的情况，以便您能够了解个人信息的概况。</strong>
    </p>
    <p>
      <strong  class="ti24">● 当您注册好兽药账号和使用我们的服务时，我们会收集您的姓名、性别、年龄、个人资料照片或视频、身份证号、电话号码、电子邮件、 社交账号、身份验证信息、位置信息和日志信息等个人信息。</strong>
    </p>
    <p>
      <strong  class="ti24">● 除了产品的核心功能外，好兽药提供一些附加功能来提升用户体验，包括：消息、互动、推送通知等。当您使用好兽药的附加功能时，我 们不会额外收集您的个人信息，除非根据本政策告知并取得您的同意</strong>
    </p>
    <p>
      <strong  class="ti24"> ● 当您在未登录状态下时，将显示为「游客」。为了更好地为您提供便捷流畅的体验，「游客」同样可以进行商品详情浏览、观看视频、点赞等基础行为。为了方便您查阅这些过往信息，我们需要获取您的IP和设备号(IMEI码)以便记录存档。</strong>
    </p>
    <p>
      <strong  class="ti24"> ● 目前，除法律法规、法律程序、诉讼或政府主管部门强制性要求外，好兽药不会主动公开披露您的个人信息，如果存在其他需要公开披 露个人信息的情形，我们会征得您的明示同意。同时，我们保证披露采取符合法律和业界标准的安全防护措施。</strong>
    </p>
    <p>
      <strong  class="ti24"> ● 您可以通过本隐私政策所列的途径访问、更正或删除您的个人信息，也可以进行隐私设置或与我们取得联系。</strong>
    </p>
    <p>
      <strong  class="ti24"> ● 您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存、共享、转让和公开披露您的相关信息。</strong>
    </p>
    <strong>目录</strong>
    <p><span  class="span_24">● 1、我们收集的个人信息。</span></p>
    <p><span  class="span_24">● 2、我们会如何使用您的个人信息。</span></p>
    <p><span  class="span_24">● 3、我们会如何使用Cookie和同类技术。</span></p>
    <p><span  class="span_24">● 4、我们会如何共享、转让、公开披露您的个人信息。</span></p>
    <p><span  class="span_24">● 5、如何管理您的个人信息。</span></p>
    <p><span  class="span_24">● 6、推广服务。</span></p>
    <p><span  class="span_24">● 7、我们会如何保护和保存您的个人信息。</span></p>
    <p><span  class="span_24">● 8、第三方提供商及其服务。</span></p>
    <p><span  class="span_24">● 9、我们会如何处理未成年人的个人信息。</span></p>
    <p><span  class="span_24">● 10、本政策如何更新。</span></p>
    <p><span  class="span_24">● 11、联系我们。</span></p>
    <strong>1.我们收集的个人信息</strong>
    <p>
      <span  class="span_24"> ● 您使用或继续使用我们的服务，即意味着同意我们按照本《隐私政策》收集、使用、储存、共享、转让和公开披露您的相关信息。</span>
    </p>
    <strong>1.1您直接提供和我们自动采集的个人信息</strong>
    <p>
      <span  class="span_24"> ● 注册信息。您使用好兽药提供的服务，可以注册并登录经注册的好兽药帐号。此时，您需要向我们提供以下信息：手机号码等。提供上述信息并同意注册协议和本政策后，您可以使用好兽药的核心业务功能，包括：浏览好兽药平台内的内容、评论、点赞、转发等。</span>
    </p>
    <p>
      <span  class="span_24"> ● 附加信息。当您使用好兽药附加业务功能时，为满足向您提供该产品和服务之目的，除注册信息外，您还需要进一步向我们提供包括但不限于您的个人身份信息、位置信息及其他为您提供服务所必需的信息，如果您不使用特定产品和服务，则无需提供相关信息（以下将详细阐明）。</span>
    </p>
    <p>
      <span  class="span_24">● 位置信息。当您开启设备定位功能并使用我们基于位置提供的相关服务时，我们会收集有关您位置的信息。该信息属于敏感信息，拒绝提供该信息仅会使您无法使用与位置信息相关的功能，但不影响您正常使用好兽药的其他功能。</span>
    </p>
    <p>
      <span  class="span_24">● 设备信息。作为游客用户的唯一标识，方便用户查看浏览历史和收藏文章，推荐用户文章信息。此时我们会收集您的以下设备信息：包括设备型号、唯一设备标识符（如 Android ID / DEVICE_ID/SIM的序列号/ UUID）、设备 MAC 地址、电信运营商、操作系统类型及型号、软件版本号。</span>
    </p>
    <p>
      <span  class="span_24">● 关键词信息。当您使用好兽药提供的搜索服务时，我们会收集您的查询关键字信息、设备信息等，为了提供高效的搜索服务，这些信息有部分会暂时存储在您的本地存储设备之中。该等关键词信息通常无法单独识别您的个人身份，不属于您的 个人信息，不在本政策的限制范围内。只有当您的搜索关键词信息与您的其他信息互有联系并可以识别您的个人身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本政策对其进行处理与保护。</span>
    </p>
    <p>
      <span  class="span_24">● 真实身份信息。当您使用好兽药提供的身份认证服务时，我们会收集您的姓名、身份证号、职业、有关身份证明、收货地址等信息。 如果您不提供这些信息，我们将无法提供相关服务。</span>
    </p>
    <p>
      <span  class="span_24">● 联系方式信息。当您向好兽药进行帐号申诉或参与营销活动时，为了方便与您联系或帮助您解决问题，我们会收集并记录 您的姓名、手机号码、电子邮件及其他联系方式等个人信息。如您拒绝提供上述信息，我们可能无法向您及时反馈投诉结 果或向您邮寄礼品（如有）。</span>
    </p>
    <p>
      <span  class="span_24">● 用户共享的信息。当您在好兽药中使用第三方提供的服务时，您同意好兽药允许该第三方收集您的帐号名称、头像及其他提 供服务所必须的个人信息。如果您拒绝第三方在提供服务时收集上述信息，将可能导致您无法在好兽药中使用该第三方服务。</span>
    </p>
    <strong>1.2我们可能从第三方获取您个人信息的情形。</strong>
    <p>
      <span  class="span_24">您也可以使用第三方账号（如微信）登录好兽药。此时您可选择授权好兽药在符合相关法律和法规规定的前提下读取您在该第三方平台上登记、公布、记录的公开信息（包括但不限于昵称、头像、关注用户列表等）。对于我们要求但第三方 无法提供的个人信息，我们仍可以要求您补充提供。好兽药可能从第三方获取您的上述信息的目的是为了记住您作为好兽药用户的登录身份，并向您提供个性化推荐，以便于好兽药向您提供更优质的产品服务。您可以在使用第三方账号登录好兽药时选 择授权好兽药可获取的个人信息的范围。但请注意，如果停止某些权限，您有可能无法享受最佳的服务体验，某些服务也可能无法正常使用。</span>
    </p>
    <strong>1.3征得授权同意的例外</strong>
    <p>
      <span  class="span_24">根据相关法律法规的规定，以下情形中收集您的个人信息无需征得您的授权同意：</span>
    </p>
    <p>
      <span  class="span_36">（1）涉及国家安全与利益、社会公共利益；</span>
    </p>
    <p>
      <span  class="span_36">（2）与犯罪侦查有关的相关活动；</span>
    </p>
    <p>
      <span  class="span_36">（3）出于维护您或他人的生命财产安全但在特殊情况下无法获得您的及时授权；</span>
    </p>
    <p>
      <span  class="span_36">（4）从其他合法公开的渠道中收集您的个人信息；</span>
    </p>
    <p>
      <span  class="span_36">（5）法律法规规定的其他情形。</span>
    </p>
    <strong>2.好兽药会如何使用您的个人信息</strong>
    <p>
      <span  class="span_24">我们会将您的个人信息用于以下目的：：</span>
    </p>
    <p>
      <span  class="span_24">● 为您提供个性化服务。</span>
    </p>
    <p>
      <span  class="span_24">● 帮助我们设计新服务，提升现有服务体验。</span>
    </p>
    <p>
      <span  class="span_24">● 在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性。</span>
    </p>
    <p>
      <span  class="span_24">● 向您发送您可能感兴趣的产品和服务的信息；向您提供与您更加相关的广告以替代普遍投放的广告；邀请您参与好兽药活动和市场调查。</span>
    </p>
    <p>
      <span  class="span_24">● 开展内部审计、数据分析和研究，以更好地改善我们的产品、服务及与用户之间的沟通。</span>
    </p>
    
    <strong>3.我们会如何使用Cookie和同类技术</strong>
    <p>
      <span  class="span_24">3.1Cookie</span>
    </p>
    <p>
      <span  class="span_24">● 您使用我们的服务时，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及 一些号码和字符。我们使用该等信息判断注册用户是否已经登录，提升服务/产品质量及优化用户体验。如您不希望个人信息保存在 Cookie中，您可对浏览器进行配置，选择禁用Cookie功能。禁用Cookie功能后，可能影响您访问好兽药或不能充分取得好兽药提供的 服务。好兽药不会将Cookie用于本政策所述目的之外的任何用途。您可根据自己的偏好管理或删除Cookie。您可以清除计算机上保存 的所有Cookie，大部分网络浏览器都设有阻止Cookie的功能。</span>
    </p>
    <p>
      <span  class="span_24">3.2设备权限调用</span>
    </p>
    <p>
      <span  class="span_24">好兽药在提供服务的过程中，可能需要您开通一些设备权限，例如通知、相册、相机、手机通讯录、蓝牙等访问权限。您也可以在设备 的设置功能中随时选择关闭部分或者全部权限，从而拒绝好兽药收集相应的个人信息。在不同设备中，权限显示方式及关闭方式可能有 所不同，具体请参考设备及系统开发方说明或指引。</span>
    </p>
    <strong>4.我们会如何共享、转让、公开披露您的个人信息 </strong>
    <p>
      <span  class="span_24">4.1共享</span>
    </p>
    <p>
      <span  class="span_24">好兽药不会在未经您同意或授权的情况下将您的个人信息提供给第三方。但是，经您确认同意，好兽药可在以下情况下共享您的个人信息。在获取同意的情况下共享：获得您的明确同意后，好兽药会与其他方共享您的个人信息。</span>
    </p>
    <p>
      <span  class="span_24">● 共享给好兽药的关联公司：在本政策声明的使用目的范围内，您的个人信息可能会与好兽药的关联公司共享。作为一项政策，我们只会共享必要的信息。关联公司如要改变个人信息的处理目的，将再次征求您的授权同意。</span>
    </p>
    <p>
      <span  class="span_24">● 共享给授权合作伙伴：好兽药可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，好兽药向您寄送礼品（如有）时，好兽药必须与物流服务提供商共享您的个人信息才能安排寄送，或者安排合作伙伴向您提供服务。我们仅会出 于特定、明确而合法的目的处理您的个人信息，并且只会共享提供服务所必要的信息。同时，我们会与其签署严格的保密协定，要求他们按照我们的说明、本政策以及其他任何相关的保密和安全措施来处理个人信息。</span>
    </p>
    <p>
      <span  class="span_24">● 第三方SDK类服务商：我们的产品中可能会包含第三方SDK或其他类似的应用程序，如您在我们平台上使用这类由第三方提供的服务时，您同意将由其直接收集和处理您的信息（如以嵌入代码、插件等形式）。目前我们产品中包含的第三方SDK服务请查阅。</span>
    </p>
    <div style="padding:10px;">
      <table class="tableclass">
      <thead>
        <tr>
          <th>SDK名称</th>
          <th>功能类型</th>
          <th>使用目的</th>
          <th>收集数据类型</th>
          <th>隐私协议链接</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>TBS腾讯浏览服务</td>
          <td>基础功能</td>
          <td>打开x5内核、在应用内打开pdf等文件的功能</td>
          <td>无</td>
          <td><a href="https://x5.tencent.com/tbs/guide/develop.html">https://x5.tencent.com/tbs/guide/develop.html</a></td>
        </tr>
        <tr>
          <td>腾讯分享登录</td>
          <td>社交类、第三方登录类</td>
          <td>微信、支付、分享等</td>
          <td>设备标识信息</td>
          <td><a href="https://www.tencent.com/zh-cn/privacy-policy.html">https://www.tencent.com/zh-cn/privacy-policy.html</a></td>
        </tr>
        <tr>
          <td>qq分享登录</td>
          <td>社交类、第三方登录类</td>
          <td>qq分享</td>
          <td>设备标识信息</td>
          <td><a href="ttps://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e">ttps://wiki.connect.qq.com/qq%e4%ba%92%e8%81%94sdk%e9%9a%90%e7%a7%81%e4%bf%9d%e6%8a%a4%e5%a3%b0%e6%98%8e</a></td>
        </tr>
        <tr>
          <td>钉钉分享登录</td>
          <td>社交类、第三方登录类</td>
          <td>钉钉分享</td>
          <td>设备标识信息</td>
          <td><a href="https://page.dingtalk.com/wow/dingtalk/act/privacypolicycn?wh_biz=tm">https://page.dingtalk.com/wow/dingtalk/act/privacypolicycn?wh_biz=tm</a></td>
        </tr>
        <tr>
          <td>极光集成</td>
          <td>极光推送基础</td>
          <td>帮助提升推送消息触达和保障系统运行稳定</td>
          <td>设备标识信息</td>
          <td><a href="https://www.jiguang.cn/license/privacy ">https://www.jiguang.cn/license/privacy </a></td>
        </tr>
        
        <tr>
          <td>极光小米推送</td>
          <td>极光推送基础</td>
          <td>帮助提升推送消息触达和保障系统运行稳定</td>
          <td>设备标识信息</td>
          <td><a href="https://www.jiguang.cn/license/privacy ">https://www.jiguang.cn/license/privacy </a></td>
        </tr>
        <tr>
          <td>极光华为推送</td>
          <td>极光推送基础</td>
          <td>帮助提升推送消息触达和保障系统运行稳定</td>
          <td>设备标识信息</td>
          <td><a href="https://www.jiguang.cn/license/privacy ">https://www.jiguang.cn/license/privacy </a></td>
        </tr>
        <tr>
          <td>极光OPPO推送</td>
          <td>极光推送基础</td>
          <td>帮助提升推送消息触达和保障系统运行稳定</td>
          <td>设备标识信息</td>
          <td><a href="https://www.jiguang.cn/license/privacy ">https://www.jiguang.cn/license/privacy </a></td>
        </tr>
        <tr>
          <td>极光vivo推送</td>
          <td>极光推送基础</td>
          <td>帮助提升推送消息触达和保障系统运行稳定</td>
          <td>设备标识信息</td>
          <td><a href="https://www.jiguang.cn/license/privacy">https://www.jiguang.cn/license/privacy</a></td>
        </tr>
        <tr>
          <td>极光魅族推送</td>
          <td>极光推送基础</td>
          <td>帮助提升推送消息触达和保障系统运行稳定</td>
          <td>设备标识信息</td>
          <td><a href="https://www.jiguang.cn/license/privacy">https://www.jiguang.cn/license/privacy</a></td>
        </tr>
        <tr>
          <td>阿里支付</td>
          <td>基础功能</td>
          <td>支付宝绑定</td>
          <td>设备标识信息、地理位置、网络信息</td>
          <td><a href="https://opendocs.alipay.com/rules">https://opendocs.alipay.com/rules</a></td>
        </tr>
        <tr>
          <td>友盟分享</td>
          <td>友盟分享基础</td>
          <td>分享基础功能</td>
          <td>设备标识信息</td>
          <td><a href="https://developer.umeng.com/docs/147377/detail/209997">https://developer.umeng.com/docs/147377/detail/209997</a></td>
        </tr>
        <tr>
          <td>阿里云视频播放</td>
          <td>基础功能</td>
          <td>视频播放</td>
          <td>无</td>
          <td><a href="https://help.aliyun.com/document_detail/51685.html">https://help.aliyun.com/document_detail/51685.html</a></td>
        </tr>
        <tr>
          <td>阿里云存储服务</td>
          <td>基础功能</td>
          <td>阿里云基础存储 功能</td>
          <td>网络信息</td>
          <td><a href="http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201802111644_32057.html?spm=a2c4g.11186623.0.0.7a0930e5q9NaZJ">http://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud201802111644_32057.html?spm=a2c4g.11186623.0.0.7a0930e5q9NaZJ</a></td>
        </tr>
        <tr>
          <td>融云IM</td>
          <td>基础功能</td>
          <td>融云基础IM功能</td>
          <td>设备标识信息</td>
          <td><a href="https://www.rongcloud.cn/privacy">https://www.rongcloud.cn/privacy</a></td>
        </tr>
        <tr>
          <td>佳信客服</td>
          <td>客服功能</td>
          <td>佳信基础客服功能</td>
          <td>设备标识信息</td>
          <td><a href="http://help.jiaxincloud.com/index.php?id=https:help.jiaxincloud.com:index.php&id=wiki:360specs:101">http://help.jiaxincloud.com/index.php?id=https:help.jiaxincloud.com:index.php&id=wiki:360specs:101</a></td>
        </tr>
        <tr>
          <td>友盟统计</td>
          <td>基础功能</td>
          <td>数据统计</td>
          <td>设备标识信息</td>
          <td><a href="https://www.umeng.com/page/policy">https://www.umeng.com/page/policy</a></td>
        </tr>
        <tr>
          <td>百度地图</td>
          <td>位置功能</td>
          <td>定位以及地图展示</td>
          <td>位置信息</td>
          <td><a href="https://map.baidu.com/zt/client/privacy/index.html">https://map.baidu.com/zt/client/privacy/index.html</a></td>
        </tr>
      </tbody>
    </table>
    </div>
    <p>目前，我们接入的第三方服务商主要包括以下几种类型：</p>
    <p>1. 用于QQ分享功能，包括收集网络位置信息，网络类型，手机号码，SIM 卡状态，IMEI，MAC 地址，WiFi 信息，外部存储，网络类型、网络状态等；</p>
    <p>2. 用于提供浏览器服务，包括获取设备标识信息（IMEI/Mac/android ID/IDFA/OPENUDID/GUID）、mac地址；</p>
    <p>3. 用于收集崩溃信息送功能，包括获取系统唯一标识符，SIM 卡序列号，ANDROID_ID；</p>
    <p>4. 用于定位以及地图展示，地理位置信息，持续定位，网络类型，网络服务运营商，IMEI，MAC 地址，WiFi 信息等；</p>
    <p>5. 用于消息分享/统计分析功能，包括获取设备信息（IMEI/MAC/Android ID/IDFA/OpenUDID/GUID/SIM卡IMSI/地理位置/移动应用列表等）；</p>
    <p>6. 用于推送功能，包括获取设备信息（网络位置信息，网络类型，手机号码，SIM 卡状态，IMEI，MAC 地址，WiFi 信息，外部存储，网络类型、网络状态）；</p>
    <p>7. 用于支付功能，包括获取常用设备信息（如IMEI/IMSI、SIM卡序列号/MAC地址、android_id）、网络信息</p>
    <p>
      <span  class="span_24">前述服务商收集和处理信息等行为遵守其自身的隐私条款，而不适用于本政策。为了最大程度保障您的信息安全，我们建议您在使用任何第三方SDK类服务前先行查看其隐私条款。为保障您的合法权益，如您发现这等SDK或其他类似的应用程序存在风险时，建议您立即终止相关操作并及时与我们取得联系。</span>
    </p>
     <p>
      <span  class="span_24">● 在法定情形下的共享：我们可能会根据法律法规规定、诉讼争议解决需要，或按行政、司法机关依法提出的要求，对外共享您 的个人信息。</span>
    </p>
    <p>
      <span  class="span_24">4.2转让</span>
    </p>
    <p>
      <span  class="span_24">我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span>
    </p>
    <p>
      <span  class="span_24">● 在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息</span>
    </p>
    <p>
      <span  class="span_24">● 在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受此隐私政策的约束， 否则我们将要求该公司、组织重新向您征求授权同意。</span>
    </p>
    <p>
      <span  class="span_24">4.3公开披露</span>
    </p>
    <p>
      <span  class="span_24">我们仅会在以下情况下，且采取符合法律和业界标准的安全防护措施的前提下，才会公开披露您的个人信息</span>
    </p>
    <p>
      <span  class="span_24">● 获得您的明确同意。</span>
    </p>
    <p>
      <span  class="span_24">● 基于法律法规、法律程序、诉讼或政府主管部门强制性要求。但我们保证，在符合法律法规的前提下，当我们收到上述披露信息的请 求时，我们会要求必须出具与之相应的法律文件。</span>
    </p>
    <strong>5.如何管理您的个人信息</strong>
    <p>
      <span  class="span_24">5.1 我们将尽一切可能采取适当的技术手段，保证收集到的有关于您的个人信息的准确性，并保证及时进行更新。</span>
    </p>
    <p>
      <span  class="span_24">5.2 您也可以通过「我的」页面，按照好兽药的相关政策及提示，对您的个人信息进行访问、更正及删除。</span>
    </p>
    <p>
      <span  class="span_24">5.3您可以通过在线申请注销或通过其他我们公示的方式申请注销您的账号。当您注销账号后，您将无法再以该账号登录和使用我们的产品与服务；且该账号使用期间已产生的但未消耗完毕的权益将被清除；该账号下的内容、信息、数据、记录等将会被删除或匿名化处理（但法律法规另有规定或监管部门另有要求的除外，如依据《中华人民共和国网络安全法》规定，您的网络操作日志将至少保留六个月的时间）；账号注销完成后，将无法恢复</span>
    </p>
    <p>
      <span  class="span_24">如您在谨慎考虑后仍决定注销您的账号，您可以在您使用的我们的产品与/或服务的相关功能设置页面或根据操作指引向我们提交注销申请。</span>
    </p>
    <strong>6.推广服务</strong>
    <p>
      <span  class="span_24">我们可能使用您的个人信息，通过我们的站内私信、短信或其他方式向您提供或推广我们或第三方的商品和服务。</span>
    </p>
    <strong>7.我们会如何保护和保存您的个人信息</strong>
    <p>
      <span  class="span_24">好兽药重视个人信息的安全。我们采取互联网业内标准做法来保护您的个人信息，防止信息遭到未经授权访问、披露、使用、修改、损坏或丢失。我 们会采取一切合理可行的措施，保护您的个人信息。我们会采取一切合理可行的措施，确保未收集与好兽药提供的服务无关的个 人信息。我们会尽全力保护您的个人信息，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，不可能始终保证信息百分 之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。 在发生个人信息安全事件的场合，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置 措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一 告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</span>
    </p>
    <p>
      <span  class="span_24">我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内。如果日后为处理跨境业务，需要向境外机构传输境内收集的相 关个人信息的，我们会事先征得您的同意，按照法律、行政法规和相关监管部门的规定执行，并通过签订协议、核查等有效措施，要求境外机构为 所获得的个人信息保密</span>
    </p>
    <p>
      <span  class="span_24">我们仅会在达到本政策所述目的所必需的时限内保存您的个人信息，但为了遵守适用的法律法规、法院判决或裁定、其他有权机关的要求、维护公 共利益等目的，我们可能会将个人信息保存时间予以适当延长。</span>
    </p>
    <strong>8.第三方提供商及其服务</strong>
    <p>
      <span  class="span_24">为确保流畅的浏览体验，您可能会收到来自好兽药及其合作伙伴外部的第三方（以下简称「第三方」）提供的内容或网络链接。好兽药对此类第三方无控制权。您可选择是否访问第三方提供的链接、内容、产品和服务。好兽药无法控制第三方的隐私和个人信息保护政策，此类第三方不受到本政策的约束。您在向第三方提交个人信息之前，请确保您阅读并认可这些第三方的隐私保护政策。</span>
    </p>
    <strong>9.好兽药会如何处理未成年人的个人信息</strong>
    <p>
      <span  class="span_24">我们鼓励父母或监护人指导未满十八岁的未成年人使用我们的服务。我们建议未成年人鼓励他们的父母或监护人阅读本政策，并建议未成年人在提 交个人信息之前寻求父母或监护人的同意和指导。但是，如果您确认自己能够完全理解本政策的全部内容且您为使用好兽药服务所进行的相关操作 行为与您的年龄、智力相适应的，则您可以独立进行相关操作（包括向我们提交您的个人信息）</span>
    </p>
    <strong>10.本政策如何更新及适用范围</strong>
    <p>
      <span  class="span_24">好兽药保留不时更新或修改本政策的权利。如果该等修改造成您在本政策下权利的实质减少，好兽药 会通过不同渠道向您发送变更通知，包括但不限于APP内公示、私信通知等方式。</span>
    </p>
    <p>
      <span  class="span_24">若您不同意修改后的隐私政策，您有权并应立即停止使用好兽药的服务。如果您继续使用好兽药的服务，则视为您接受好兽药对本政策相关条款所做的修改。</span>
    </p>
    <p>
      <span  class="span_24">好兽药的所有服务均适用本政策。但某些服务有其特定的隐私政策，该等特定的隐私政策更具体地说明好兽药在该服务中如何处理您的信息。如本政策 与特定服务的隐私政策有不一致之处，请以该特定隐私政策为准。</span>
    </p>
    <strong>11.联系我们</strong>
    <p>1、好兽药由北京集橙信息技术有限公司提供，如果您对个人信息保护问题有投诉、建议、疑问，您可以直接将问题发送至(han.xiaoxue@sslab.com.cn)，我们核查并验证您的用户身份后会及时反馈您的投诉与举报。</p>
    <p>2、如您对本隐私政策内容有任何疑问、意见或建议，您可拨打（400-050-9611）客服热线与我们联系。</p>
    <p style="height:50px;width:10px;">   </p>
  </div>
</div>
</template>

<script>
export default {
  name: 'agreement',
}
</script>

<style scoped>
  @import '../assets/style/style.css';
</style>

<style lang="scss">
  .container {
    -webkit-user-select: text;
    .text-fw{
      font-weight: bold;
    }
    .ti24{
      text-indent: 24px;
    }
    .span_24{
      text-indent: 24px;display: inline-block;
    }
    .span_36{
      text-indent: 36px;display: inline-block;
    }
  }
  .tableclass {
    width: 100%;
    margin-bottom: 10px;
    border-collapse: collapse;
    border: 1px solid #666;
    font-size: 10px;
    color: #000;
    text-align: center;
    thead {
      tr {
        th {
          padding: 5px;
          line-height: 20px;
          border: 1px solid #666;
          vertical-align: middle;
          font-weight: bold;
        }
      }
    }
    tbody {
      tr {
        td {
          padding: 5px;
          line-height: 20px;
          border: 1px solid #666;
          vertical-align: middle;
          a {
            word-wrap: break-word;
            word-break: break-all;
            color: #0186FF;
          }
        }
      }
    }
  }
</style>
